export const DeclinedOccupations = [
  {
    code: 'A003',
    desc: 'Actor/Actress -With Stunt Work'
  },
  {
    code: 'A425',
    desc: 'Aerial Erector - Hgts >15 mtrs'
  },
  {
    code: 'A010',
    desc: 'Air Con Worker - Hgts >15 mtrs'
  },
  {
    code: 'A024',
    desc: 'Armed Forces - Bomb Disposal'
  },
  {
    code: 'A449',
    desc: 'Armed Forces - Commando'
  },
  {
    code: 'A465',
    desc: 'Bargeman - Quarrying'
  },
  {
    code: 'A043',
    desc: 'Bargeman / Barge Operator'
  },
  {
    code: 'A049',
    desc: 'Boatman / Ferryman'
  },
  {
    code: 'A050',
    desc: 'Boatswain / Bosun'
  },
  {
    code: 'A051',
    desc: 'Body Guard'
  },
  {
    code: 'A054',
    desc: 'Bouncer'
  },
  {
    code: 'A506',
    desc: 'Cable Laying Diver'
  },
  {
    code: 'A532',
    desc: 'Chemical Engineer - Offshore'
  },
  {
    code: 'A087',
    desc: 'Cleaner - Window'
  },
  {
    code: 'A097',
    desc: 'Construction - Hgts > 15 mtrs'
  },
  {
    code: 'A107',
    desc: 'Crane Driver - Construction'
  },
  {
    code: 'A570',
    desc: 'Crane Driver - Docks/Shipyard'
  },
  {
    code: 'A122',
    desc: 'Demolition Work - Explosives'
  },
  {
    code: 'A121',
    desc: 'Demolition Work -No Explosives'
  },
  {
    code: 'A130',
    desc: 'Diver - Armed Forces (Alias: Armed Forces - Diver)'
  },
  {
    code: 'A133',
    desc: 'Diver - Instructor'
  },
  {
    code: 'A131',
    desc: 'Diver - Other No Explosives'
  },
  {
    code: 'A132',
    desc: 'Diver - Other With Explosives'
  },
  {
    code: 'A134',
    desc: 'Docker / Dock Worker'
  },
  {
    code: 'A141',
    desc: 'Dredgerman / Dredger Driver'
  },
  {
    code: 'A605',
    desc: 'Driller - Oil &Gas (Offshore)'
  },
  {
    code: 'A609',
    desc: 'Driver - Excavator'
  },
  {
    code: 'A612',
    desc: 'Driver - Refuse'
  },
  {
    code: 'A615',
    desc: 'Dustman/Refuse Collector'
  },
  {
    code: 'A622',
    desc: 'Electrician - Offshore'
  },
  {
    code: 'A634',
    desc: 'Engineer - Hgts > 15 mtrs'
  },
  {
    code: 'A162',
    desc: 'Engineer/Techn  - Oil Rig'
  },
  {
    code: 'A161',
    desc: 'Engineer/Techn - Offshore'
  },
  {
    code: 'A641',
    desc: 'Erector-Metal Manufacture (>15 mtrs)'
  },
  {
    code: 'A648',
    desc: 'Explosives Inspector'
  },
  {
    code: 'A168',
    desc: 'Explosives Worker / Blaster'
  },
  {
    code: 'A175',
    desc: 'Fisherman / Fishing Boat Crew'
  },
  {
    code: 'A672',
    desc: 'Floorman - Oil Rig'
  },
  {
    code: 'A185',
    desc: 'Foreman/Supervisor - Offshore'
  },
  {
    code: 'A186',
    desc: 'Foreman/Supervisor - Oil Rig'
  },
  {
    code: 'A693',
    desc: 'Gantry Crane Driver'
  },
  {
    code: 'A703',
    desc: 'Geologist - Oil & Gas (Offshore)'
  },
  {
    code: 'A204',
    desc: 'Grave Digger'
  },
  {
    code: 'A716',
    desc: 'Head Roustabout - Oil & Gas'
  },
  {
    code: 'A208',
    desc: 'Heavy Vessel - Crew / Officer'
  },
  {
    code: 'A721',
    desc: 'Helicopter Pilot - Oil Rig'
  },
  {
    code: 'A722',
    desc: 'Helicopter Pilot - Onshore'
  },
  {
    code: 'A232',
    desc: 'Jockey'
  },
  {
    code: 'A763',
    desc: 'Kerb Layer'
  },
  {
    code: 'A242',
    desc: 'Lashing Worker'
  },
  {
    code: 'A249',
    desc: 'Linesman - Electrical Supply'
  },
  {
    code: 'A262',
    desc: 'Manager - Offshore/Oil Rig'
  },
  {
    code: 'A811',
    desc: 'Martial Arts Instructor'
  },
  {
    code: 'A273',
    desc: 'Missionary'
  },
  {
    code: 'A288',
    desc: 'Oil Rig / Off Shore Workers'
  },
  {
    code: 'A289',
    desc: 'Oil Rig Vessel - Crew/Officer'
  },
  {
    code: 'OT03',
    desc: 'Other-C3-D3 (Moderate manual work/outdoor work)'
  },
  {
    code: 'OT04',
    desc: 'Other-C4-D4 (Semi/unskilled/moderate manual work)'
  },
  {
    code: 'OT49',
    desc: 'Other-C4-D9 (Semi/unskilled/mostly manual work)'
  },
  {
    code: 'A848',
    desc: 'Painter - Exterior (Hgts >15 mtrs)'
  },
  {
    code: 'A304',
    desc: 'Pilot - Airforce (Captain)'
  },
  {
    code: 'A305',
    desc: 'Pilot - Airforce (Instructor)'
  },
  {
    code: 'A306',
    desc: 'Pilot - Airforce (Lieutenant)'
  },
  {
    code: 'A309',
    desc: 'Pilot - Airforce (Trainee)'
  },
  {
    code: 'A863',
    desc: 'Pilot - Non International Airline'
  },{
    code: 'A866',
    desc: 'Politician'
  },
  {
    code: 'A913',
    desc: 'Rigger - Oil & Gas (Offshore)'
  },
  {
    code: 'A343',
    desc: 'Riveter'
  },
  {
    code: 'A345',
    desc: 'Roofer'
  },{
    code: 'A346',
    desc: 'Sailor / Seaman'
  },
  {
    code: 'A349',
    desc: 'Salvage Vessel Crew / Officer'
  },
  {
    code: 'A350',
    desc: 'Scaffolder'
  },
  {
    code: 'A016',
    desc: 'Security Guard/Officer-Armed'
  },{
    code: 'A371',
    desc: 'Steel Worker'
  },
  {
    code: 'A372',
    desc: 'Stevedore'
  },{
    code: 'A949',
    desc: 'Stone Breaker'
  },
  {
    code: 'A950',
    desc: 'Stunt Man'
  },{
    code: 'A953',
    desc: 'Surveyor - Oil & Gas (Offshore)'
  },
  {
    code: 'A964',
    desc: 'Tower Crane Driver'
  },{
    code: 'A394',
    desc: 'Tugboat Operator'
  },
  {
    code: 'A408',
    desc: 'Well Worker - Water Supply'
  }


]